import React from 'react'
import ImagesUroliftGallery from "./ImagesUroliftGallery"
import {Link} from "@material-ui/core"

const HIFEM_BG = () => {
    return (
        <section id="about1">
            <div className="row">
<h2>Лечение с HIFEM в нашата урологична практика</h2>

<p>HIFEM, безболезнена и неинвазивна терапия, използва електромагнитни полета за стимулиране на мускулите на тазовото дъно както при жените, така и при мъжете. Терапията HIFEM е предназначена за повишаване на силата на мускулите на тазовото дъно, като цели да се справи с различни медицински състояния, свързани с тези мускули, вариращи от незадържане на урина до еректилна дисфункция.</p>

<h2>Медицински състояния, лекувани с HIFEM</h2>

<p>Инконтиненция на урина: HIFEM може да увеличи силата на мускулите на тазовото дъно за ефективно лечение на незадържане на урина.
След простатектомия: След операция за простатектомия при пациенти с рак на простатата често се наблюдава незадържане на урина. Терапията с HIFEM може да се използва за подпомагане в такива случаи.
Еректилна дисфункция: Еректилната дисфункция, еякулацията и оргазмът са неразривно свързани с дисфункцията на тазовото дъно. HIFEM може да повиши активността на мускулите на тазовото дъно, подобрявайки мускулната контракция по неинвазивен начин.</p>

<h2>Как действа HIFEM</h2>

<p>Терапията HIFEM използва специализирано устройство, излъчващо електромагнитно поле, насочено специално към мускулите на тазовото дъно, докато пациентът е в седнало положение. По този начин се стимулират хиляди контракции на мускулите на тазовото дъно по време на една терапевтична сесия, което предлага по-ефективен и ефикасен подход в сравнение с конвенционалните упражнения, като например само упражненията на Кегел.</p>

<h2>Може ли да се подложа на HIFEM терапия?</h2>

<p>HIFEM е безопасна и ефективна терапия както за мъже, така и за жени, които искат да увеличат силата на мускулите на тазовото дъно. Въпреки това, за да се определи нейната целесъобразност за настоящото ви здравословно състояние, консултацията с лекар, особено с уролог, е от решаващо значение. Вашият лекар ще оцени състоянието ви, за да определи дали тази терапия е подходящ подход за вашите медицински нужди.</p>

<h2>Процедура за терапия с HIFEM</h2>

<p>Терапията HIFEM включва сядане на специализиран стол HIFEM. Електромагнитните вълни от стола стимулират мускулите на тазовото дъно, което ви позволява да усетите контракциите по време на процедурата. Този неинвазивен и безболезнен процес ви позволява да се върнете към обичайните си дейности веднага след терапията.</p>

<h2>Продължителност на терапията HIFEM</h2>

<p>Един сеанс на терапия HIFEM продължава приблизително 28 минути. Повечето хора обикновено се нуждаят от около шест сеанса, като следват графика на лекаря.</p>

<h2>Колко време е необходимо, за да видите резултатите?</h2>

<p>Макар че срокът за получаване на резултати е различен при различните хора, като цяло въздействието на терапията HIFEM може да се усети след първия сеанс, като ефективността се увеличава през седмиците след следващите сеанси.</p>

            </div>
        </section>
    )
}

export default HIFEM_BG



// WEBPACK FOOTER //
// ./src/Components/HIFEM/HIFEM_BG.js